import { createSlice } from '@reduxjs/toolkit'

export const plansSlice = createSlice({
  name: 'plans',
  initialState: {
    showCheckout: false,
    showMap: false,
    defaultPlanId: '',
    landingType: 'fullPrice',
    plan: '',
    showPaywall: false,
    checkoutVisited: null,
  },
  reducers: {
    setDefaultPlanId: (state, action) => {
      state.defaultPlanId = action.payload
    },
    setShowCheckout: (state, action) => {
      state.showCheckout = action.payload
    },
    setShowMap: (state, action) => {
      state.showMap = action.payload
    },
    setLandingType: (state, action) => {
      state.landingType = action.payload || 'fullPrice'
    },
    setPlan: (state, action) => {
      state.plan = action.payload
    },
    setShowPaywall: (state, action) => {
      state.showPaywall = action.payload
    },
    setCheckoutVisited: (state, action) => {
      state.checkoutVisited = action.payload;
    },
  },
});

export const {
  setShowCheckout,
  setDefaultPlanId,
  setShowMap,
  setPlan,
  setLandingType,
  setShowPaywall ,
  setCheckoutVisited,
} = plansSlice.actions;

export const selectShowCheckout = (state) => state.plans.showCheckout
export const selectDefaultPlanId = (state) => state.plans.defaultPlanId
export const selectShowMap = (state) => state.plans.showMap
export const selectPlan = (state) => state.plans.plan;
export const selectLandingType = (state) => state.plans.landingType;
export const selectShowPaywall = (state) => state.plans.showPaywall
export const selectIfCheckoutVisited = (state) => state.plans.checkoutVisited

export default plansSlice.reducer
